// extracted by mini-css-extract-plugin
export default {"main-container":"informes_main-container__8uSEM","body-container":"informes_body-container__YRZGw","reports-container":"informes_reports-container__NW-5S"};